import { createSelector } from 'reselect'
import { selectCustomerRatingSettingsById } from './selectCustomerRatingSettingsById'

export const selectCustomerRatingSettings = createSelector(
  selectCustomerRatingSettingsById,
  byId => Object.values(byId)
)
